import { Pipe, PipeTransform } from '@angular/core';
import { PAGES_WITHOUT_TRANSLATION } from '@core/api/constants/not-translated-pages.constants';
import { TRANSLATED_URLS } from '@core/api/constants/translated-urls.constants';
import { DEFAULT_LANG } from '@translate/constants/available-langs';
import { LanguageService } from '@translate/services/language.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'addLangPrefix',
  standalone: true,
})
export class AddLangPrefixPipe implements PipeTransform {
  constructor(private languageService: LanguageService) {}

  transform(link: string[] | string): Observable<string> {
    if (!link) {
      return null;
    }

    return this.languageService.langChanges$.pipe(map(() => this.mapLink(link)));
  }

  private mapLink(link: string[] | string): string {
    const activeLang: string = this.languageService.activeLang;
    link = Array.isArray(link) ? link.join('/') : link;

    const isForeignLink: boolean = link?.startsWith('https://');
    const isLinkHasLangPrefix: boolean = link?.includes(`/${activeLang}/`);
    const isPageTranslated: boolean = !PAGES_WITHOUT_TRANSLATION.find((page: string) =>
      link.includes(page),
    );

    const needsModification: boolean =
      !isForeignLink && !isLinkHasLangPrefix && activeLang !== DEFAULT_LANG && isPageTranslated;

    if (needsModification) {
      const cleanPath: string = link.replace(/^\//, '');

      if (TRANSLATED_URLS[cleanPath]) {
        link = TRANSLATED_URLS[cleanPath][activeLang] || link;
      }
    }

    return needsModification ? `/${activeLang}/${link}` : link;
  }
}
